import { useEffect, useState } from 'react'

import { DEFAULT_DELAY } from './constants'
import type { UseDebounceParams } from './types'

export const useDebounce = <T>({ value, delay }: UseDebounceParams<T>): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay ?? DEFAULT_DELAY)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}
